<template>
  <b-container fluid>
    <loading :active.sync="isGenerando" :is-full-page="true"></loading>
  
    <b-row align-h="center"  >
      <b-col cols="12" md="10" lg="7">
        <b-row no-gutters > 
          <b-col >
            <b-img v-if="tipo=='predial'" :src="require('@/assets/predial/'+mpio+'.jpg')"  fluid-grow alt="Fluid-grow image"></b-img>
            <b-img v-if="tipo=='agua'" :src="require('@/assets/agua/'+mpio+'.jpg')"  fluid-grow alt="Fluid-grow image"></b-img>
          </b-col>
        </b-row>


        <!----------------------------------------------------Collapse MENSUAL------------------------------------------------------>
         <b-row v-if="servicios.pagoPadronMensual && tipo=='mensual'" class="margin" >
          <b-button :class="them" block style="text-align:left;" @click="cleanResults(); isShowCollapseMensual=!isShowCollapseMensual;">Colegiatura</b-button>
          <b-collapse v-model="isShowCollapseMensual" style="width: 100%;" accordion="portalContribuyente" role="tabpanel">
            <b-card>
              <b-row>
                <b-col cols="12" lg="12">  
                  <b-alert variant="danger" dismissible @dismissed="cleanMsgError" :show="msgErrorContribuyente != ''">
                      {{msgErrorContribuyente}}
                  </b-alert>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="3">
                  <b-form-group label="Número de cuenta:">
                    <b-form-input :state="!$v.cuentaMensual.$invalid" type="text" v-model.trim="cuentaMensual"></b-form-input>
                    <div class="error" v-if="!$v.cuentaMensual.alphaNum">La cuenta solo debe contener caracteres alfanuméricos.</div>
                    <div class="error" v-if="!$v.cuentaMensual.minLength">El número de cuenta es muy corto.</div>
                    <div class="error" v-if="!$v.cuentaMensual.maxLength">El número de cuenta es muy largo.</div>
                    <div class="error" v-if="!$v.cuentaMensual.required">Ingrese su número de cuenta.</div>            
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="3">
                  <vue-recaptcha ref="recaptchaPredial" sitekey="6LdD09sUAAAAANCvTN2xMZqvfMOvzkdkOB1Zcpok" @verify="captchaPredialFilled" @expired="captchaPredialExpired" :loadRecaptchaScript="true" />
                </b-col>
              </b-row>
              <div class="error" v-if="isShowMsgCaptcha">Por favor complete el captcha.</div>
              <br>
              <b-row>
                <b-col cols="12" lg="3">
                  <b-button block size="lg" variant="success" @click="validarFormularioMensual">
                    <b-spinner v-if="isCalculando"></b-spinner>
                    <strong v-if="isCalculando"> Consultando . . .</strong>
                    <strong v-if="!isCalculando"> Consultar Adeudo</strong>
                  </b-button>
                </b-col>
              </b-row>
              <LiqTable v-if="totalLiquidacion!=null" :datosPago="datosPago" :parcialidades="parcialidades" :totalLiquidacion="totalLiquidacion" :getLiquidacion="getLiquidacionSelected" :resumen="resumenLiquidacion"/>
              <b-row align-h="center">
                <b-col cols="12" lg="12">
                  <b-alert variant="danger" dismissible @dismissed="cleanMsgError" :show="msgErrorGenLinea != ''">
                    {{msgErrorGenLinea}}
                  </b-alert>
                </b-col>
              </b-row>
              <b-row align-h="center" v-if="totalLiquidacion != null">
                <b-col cols="12" xl="4" lg="5" md="6">
                  <b-dropdown style="width:100%" class="dropdown" size="lg" split right @click="generarLineaCaptura(false)" variant="success">
                    <template v-slot:button-content>
                      <b-icon icon="download" aria-hidden="true"></b-icon> Formato de Pago
                    </template>
                    <b-dropdown-item @click="generarLineaCaptura(true)">Solo Imprimir</b-dropdown-item>
                  </b-dropdown>
                </b-col>
                <b-col cols="12" xl="3" lg="5" md="6" v-if="servicios.pagoEnLinea">
                  <b-button size="lg" variant="secondary" @click="abrirModalPago">
                    <b-icon icon="credit-card" aria-hidden="true"></b-icon> Pagar
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>
        </b-row>
        <!----------------------------------------------------Collapse ------------------------------------------------------>
        <b-row v-if="servicios.pagoPredial || servicios.pagoAgua" no-gutters style="margin:15px;" class="mt-5">
          <b-col>
            <b-row>
              <b-col v-if="totalLiquidacion==null" class="card-form-primary " >
                <b-row class="mt-3">
                  <b-col cols="12" lg="12">  
                    <b-alert variant="danger" dismissible @dismissed="cleanMsgError" :show="msgErrorContribuyente != ''">
                        {{msgErrorContribuyente}}
                    </b-alert>
                  </b-col>
                </b-row>
                <b-row>

                  <b-col cols="12" md="6" lg="6" v-if="tipo=='predial' && !this.mpio.includes('zacatlan')">
                    <h6><b-icon icon="house-door"/> {{nombreClavePredio}}</h6>
                    <b-form-group >
                      <b-form-input :state="!$v.claveCatastral.$invalid" type="text" v-model.trim="claveCatastral"></b-form-input>
                      <div class="error" v-if="!$v.claveCatastral.minLength">La {{nombreClavePredio}} es incorrecta.</div>
                      <div class="error" v-if="!$v.claveCatastral.maxLength">La {{nombreClavePredio}} es incorrecta.</div>
                      <div class="error" v-if="!$v.claveCatastral.required">Ingrese su {{nombreClavePredio}}.</div>            
                    </b-form-group>
                  </b-col>

                  <!------------- zacatlan ----------------->
                  <b-col cols="12" md="6" lg="6" v-if="tipo=='predial' &&this.mpio.includes('zacatlan')" class="mb-4"> 
                    <h6><b-icon icon="map-fill"/> Seleccione el tipo de predio</h6>  
                    <b-form-select v-model="tipoPredio" :options="listaTiposPredio"></b-form-select>                   
                    <h6 class="mt-4"><b-icon icon="house-door"/> Ingrese el número de cuenta</h6>
                    <b-input-group>                      
                      <b-input-group-prepend is-text>
                        <b>{{tipoPredio.substring(0,1)}}</b>
                      </b-input-group-prepend>
                      <b-form-input :state="!$v.claveCatastral.$invalid" type="text" v-model.trim="claveCatastral"></b-form-input>
                    </b-input-group>
                    <b-form-group >                      
                      <div class="error" v-if="!$v.claveCatastral.minLength">La {{nombreClavePredio}} es incorrecta.</div>
                      <div class="error" v-if="!$v.claveCatastral.maxLength">La {{nombreClavePredio}} es incorrecta.</div>
                      <div class="error" v-if="!$v.claveCatastral.required">Ingrese su {{nombreClavePredio}}.</div>            
                    </b-form-group>
                    <h6><b-icon icon="person-fill"/> Ingrese los apellidos del propietario (En mayúsculas sin acentos)</h6>  
                    <b-form-input :state="datoV!=null&&datoV.length>5" v-model="datoV" ></b-form-input>
                  </b-col>


                  <!------------- tultepec ----------------->
                  <b-col cols="12" md="6" lg="6" v-if="tipo=='agua' &&this.mpio.includes('tultepec')">   
                    <h6><b-icon icon="map-fill"/> Seleccione la zona del servicio</h6>                 
                    <b-form-select v-model="zonaTultepec" :options="listaColoniasTultepec"></b-form-select>                   
                    <h6 class="mt-4"><b-icon icon="house-door"/> Ingrese No. de cuenta ó contrato a 8 posiciones</h6>
                    <b-input-group>                      
                      <b-input-group-prepend is-text>
                        <b>{{zonaTultepec.substring(0,1)}}</b>
                      </b-input-group-prepend>
                      <b-form-input  type="text" v-model.trim="cuentaAgua"></b-form-input>
                    </b-input-group>
                  </b-col>

                  <b-col cols="12" md="6" lg="6" v-if="tipo=='agua' && !this.mpio.includes('tultepec')">                    
                    <b-form-group >
                      <h6 class="mt-4"><b-icon icon="house-door"/> Ingrese No. de cuenta ó contrato</h6>
                      <b-form-input :state="!$v.cuentaAgua.$invalid" type="text" v-model.trim="cuentaAgua"></b-form-input>
                      <div class="error" v-if="!$v.cuentaAgua.minLength">El número de cuenta/contrato es incorrecto.</div>
                      <div class="error" v-if="!$v.cuentaAgua.maxLength">El número de cuenta/contrato es incorrecto.</div>
                      <div class="error" v-if="!$v.cuentaAgua.required">Ingrese la información.</div>            
                    </b-form-group>
                  </b-col>
                 
                </b-row>
                <b-row>
                  <b-col cols="12" lg="3">
                    <vue-recaptcha ref="recaptchaPredial" sitekey="6LdD09sUAAAAANCvTN2xMZqvfMOvzkdkOB1Zcpok" @verify="captchaPredialFilled" @expired="captchaPredialExpired" :loadRecaptchaScript="true" />
                  </b-col>
                </b-row>
                <div class="error" v-if="isShowMsgCaptcha">Por favor complete el captcha.</div>
                <br>
                <b-row>
                  <b-col cols="12" md="6" lg="5">
                    <b-button block size="lg" :variant="mpio.includes('huix')?'info': 'success'" @click="validarFormulario()">
                      <b-spinner v-if="isCalculando"></b-spinner>
                      <strong v-if="isCalculando"> Calculando . . .</strong>
                      <strong v-if="!isCalculando"> Consultar Adeudo</strong>
                    </b-button>
                    <br>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
              
            <div v-if="totalLiquidacion!=null">
              <b-row align="center"><b-col style="margin-bottom:15px;"><b-button variant="danger" size="lg" pill @click="cleanResults"><b-icon icon="arrow-left-circle"/> Regresar</b-button></b-col></b-row>
            </div>

            <b-row>
              <b-col>
                <LiqTable class="mb-5" v-if="totalLiquidacion!=null" :datosPago="datosPago" :parcialidades="parcialidades" :totalLiquidacion="totalLiquidacion" :getLiquidacion="getLiquidacionSelected" :resumen="resumenLiquidacion"/>
              </b-col>
            </b-row>
            
            
            <b-row align-h="center">
              <b-col cols="12" lg="12">
                <b-alert variant="danger" dismissible @dismissed="cleanMsgError" :show="msgErrorGenLinea != ''">
                  {{msgErrorGenLinea}}
                </b-alert>
              </b-col>
            </b-row>
            <b-row align-h="center" v-if="totalLiquidacion != null" class="mb-5">
              <b-col cols="12" xl="6" lg="6" md="6" v-if="servicios.pagoEnLinea">
                <b-button block size="lg" variant="success" @click="solicitarPago">
                  Pagar En Linea <b-icon icon="credit-card" aria-hidden="true"></b-icon>
                </b-button>
                <br>
              </b-col>
              
              <b-col cols="12" xl="6" lg="6" md="6"> 
                <b-button block size="lg"  @click="generarLineaCaptura(false)" variant="info">
                    Descargar Formato de Pago <b-icon icon="download" aria-hidden="true"></b-icon>
                </b-button>
                <br>
              </b-col>       -
              
            </b-row>
          </b-col>
        </b-row>


      </b-col>
    </b-row>
       
    
    <!--------------------------------------------------------------------- MODALS -------------------------------------------------------------------->

    <b-modal @shown="focusModalPago"  scrollable title="Pago En Línea" v-model="isShowModalInfoPagoEnLinea" @hide="borrarDatosPago()" hide-footer>
      <b-row align="center" align-h="center" v-if="urlForPayment==null || urlForPayment==''">
        <b-col col1s="11">
          <b-icon style="color:#DAD7FF" icon="envelope" font-scale="6"/>
        </b-col>
        <b-col cols="11" >
          <h6>Ingresa un correo electrónico</h6>
          <b-form-group label="Lo usaremos para enviarte tu recibo de pago:">
            <b-form-input ref="focusCorreoPago" style="text-align: center;" type="email" v-model.trim="correoParaPago"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col><b-button @click="generarPagoEnLinea" :disabled="correoParaPago==null" size="lg" pill :variant="mpio.includes('huix')?'info': 'success'">Continuar <b-icon icon="arrow-right-circle"/></b-button><br><br><br></b-col>
        <b-col class="mb-3" cols="12">Al dar click en continuar, aceptas nuestro <a :href="servicios.urlTerminos" target="_blank">Aviso de Privacidad, Términos y Condiciones.</a>.</b-col>
      </b-row>

<!--      aqui antes se mostraba la pagina de pago en el mismo modal, ahora ya se redirecciona a la pagina
      <b-row v-if="urlForPayment!=null && urlForPayment!=''" no-gutters>
        <b-col cols="12" >
          <div style="margin-left:-17px; margin-right:-17px; margin-top:-20px;">
            
            <iframe style="width:100%; height:1600px;" scrolling="no" :src="urlForPayment"></iframe>
          </div>          
          
        </b-col>
      </b-row> -->


    </b-modal>

    <b-modal title="Formato de Pago" dialog-class="modal-fullscreen" v-model="isShowModalLineaCaptura" size="lg" hide-footer header-bg-variant="dark" header-text-variant="light">
      <iframe id="embed1"  width="100%"  height="80%" scrolling="yes"  :src="'data:application/pdf;base64,'+this.pdfGenerated"></iframe> 
      <!-- <b-button block variant="success" @click="printOrdenPago" size="lg">IMPRIMIR</b-button> -->
      <b-button block variant="success" @click="downloadLinea" size="sm">DESCARGAR <b-icon icon="download"/></b-button>
      

    </b-modal>
  </b-container>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import LiqTable from '@/components/cobro/LiqTable.vue';
import { minLength, alphaNum, maxLength, required} from 'vuelidate/lib/validators';
import { mapState} from 'vuex';
import { server, getPostConfig, handledError, getGetConfig } from '@/axios-tools';
import axios from 'axios';
import { genPdfLinea } from '@/vue-tools';
import VueRecaptcha from 'vue-recaptcha';
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)


export default {
  computed:{
    ...mapState({
      parcialidades: state => state.contribuyente.parcialidades,
      totalLiquidacion: state => state.contribuyente.totalLiquidacion,
      resumenLiquidacion: state => state.contribuyente.resumenLiquidacion,
      datosPago: state => state.contribuyente.datosPago,
      isCalculando: state => state.contribuyente.isCalculando,
      isGenerando: state => state.contribuyente.isGenerando,
      idxUltParcialidad: state => state.contribuyente.idxUltParcialidad,
      msgErrorContribuyente: state => state.contribuyente.msgErrorContribuyente,
      msgErrorGenLinea: state => state.contribuyente.msgErrorGenLinea,
      terminosServicio: state => state.contribuyente.catalogContribuyente.terminosServicio,
      thems: state => state.contribuyente.catalogContribuyente.thems,
      test: state => state.contribuyente.test
    }),
    them(){
      var them;
      if(this.$route.params.municipio == this.thems.teotihuacan){
        them = this.thems.teotihuacan;
      }else if(this.$route.params.municipio == this.thems.demo){
        them =  this.thems.demo;
      }
      return them;
    },
    tipo:function(){
      return document.URL.split("/").pop() == 'portalcontribuyente' ? 'predial' : 'agua';
    },
    nombreClavePredio:function(){
      return this.mpio== 'zacatlan' ? 'Cuenta Predial' : 'Clave Catastral';
    }
  },
  data(){
    return{
      servicios:{
        facturacion: false,
        pagoAgua: false,
        pagoAnuncios: false,
        pagoBebidas: false,
        pagoComercio: false,
        pagoEnLinea: false,
        pagoEstacionamiento: false,
        pagoJuegos: false,
        pagoPadronMensual: false,
        pagoPanteon: false,
        pagoPredial: false,
        urlTerminos: false,
      },
      isShowCollapseMensual:false,
      isShowCollapsePredial:true,
      
      datoV:null,
      clavePost:null,
      claveCatastral:null,
      cuentaAgua:null,
      isValidForm:null,
      tipoPadron:null,
      tipoLiq:"1",
      contenidoLineaCaptura:null,
      isShowModalLineaCaptura:false,
      
      isShowModalInfoPagoEnLinea:false,
      pdfGenerated: null, /*Almacena el url con blob del pdf para mostrar en el iframe*/
      captchaPredial:null,
      correoParaPago:null,
      isShowMsgCaptcha:false,
      collapseColor: "secondary",
      
      urlForPayment:'',

      mpio : this.$route.params.municipio,

      listaColoniasTultepec:[
        'C - Zona Centro y Colonias Aledañas',
        'H - El Dorado',
        'H - El Bosque',
        'H - Hacienda del Jardín I',
        'H - Hacienda del Jardín II',
        'H - Hacienda del Jardín III',
        'H - La Antigua',
        'H - Paseos de Tultepec I',
        'H - Paseos de Tultepec II',
        'U - Arcos de Tultepec',
        'U - Hacienda Real de Tultepec',
        'U - Unidad Habitacional CTM',

      ],
      tipoPredio:"URBANO",
      listaTiposPredio:[
        'URBANO',
        'RUSTICO'
      ],
      zonaTultepec : 'C - Zona Centro y Colonias Aledañas'

    }
  },
  components: {
    LiqTable,
    VueRecaptcha,
    Loading
  },
  created: function () {
      this.getServices();
    },
  methods:{
    getServices(){
      axios(
        getGetConfig(server.servicios, null, null, {codeClient:this.$route.params.municipio})
      )
      .then(res => {
        this.servicios = res.data;
      }).catch(err => {
        handledError(err, server.servicios, this.$router, this.$store);
      });
    },
    downloadLinea(){
        var downloadPdf = document.createElement('a');
        downloadPdf.setAttribute('href', 'data:application/pdf;base64,'+this.pdfGenerated);
        downloadPdf.setAttribute('download', "formatoPago.pdf");
        downloadPdf.click();
    },
    countDownChanged(isShowMsgErrorCodigo) {
      this.isShowMsgErrorCodigo = isShowMsgErrorCodigo;
    },
    showModalAceptarTerminos(){
      this.isShowModalAceptarTerminos=true;
    },
    
    cleanMsgError(){
      /* Se manda cadena vacia a MsgErrorContribuyente en el store, ya que el <b-alert> para mostrar errores solo se muestra si este es diferente de cadena vacia */
      this.$store.commit("updateMsgErrorContribuyente", '');
      this.$store.commit("updateMsgErrorGenLinea", '');
    },
    
    captchaPredialFilled(token){
      this.captchaPredial = token;
      this.isShowMsgCaptcha = false;
    },
    captchaPredialExpired(){
      this.captchaPredial = null;
    },
    
    cleanResults(){
      /* Limpia toda la información de la liquidación en el store, cuando se manda una nueva petición */
      this.$store.commit("updateDatosPagoContribuyente", null);
      this.$store.commit("updateParcialidadesContribuyente", null);
      this.$store.commit("updateTotalLiquidacionContribuyente", null);
      this.$store.commit("updateMsgErrorContribuyente", '');
      this.isShowMsgCaptcha = false;
      window.scrollTo(0, 0);
      
      
    },
    
    cleanCaptchas(){
      /* Una vez que se ha enviado una petición 'consultaadeudo', es necesario limpiar los token(captcha), ya que solo son validos para una petición */
      this.captchaPredial = null;
      
      /* Despues de limpiar los token, para que un usuario pueda solicitar un nuevo token se resetean los captcha */
      if(this.$refs.recaptchaPredial != null){this.$refs.recaptchaPredial.reset();}
      
    },
    validarFormularioMensual(){
      if(this.captchaPredial != null){
        if(!this.$v.cuentaMensual.$invalid && !this.isCalculando){
          this.getLiquidacion("1", this.cuentaMensual, this.captchaPredial, "2");
        }
      }else{
        this.isShowMsgCaptcha = true;
      }
    },
    validarFormulario(){
      if(this.tipo == 'predial'){
        if(this.captchaPredial != null){
          
          if(!this.$v.claveCatastral.$invalid && !this.isCalculando){
            this.getLiquidacion("1", this.claveCatastral, this.captchaPredial, "1");
          }
        }else{
          this.isShowMsgCaptcha = true;
        }
      }
      if(this.tipo == 'agua'){
        //tultepec
        if(this.mpio=='tultepec'){
          this.cuentaAgua = this.zonaTultepec.substring(0,1)+this.cuentaAgua.replace('-','').replace('U','').replace('C','').replace('H','');
        }

        if(this.captchaPredial != null){
          if(!this.$v.cuentaAgua.$invalid && !this.isCalculando){
            this.getLiquidacion("3", this.cuentaAgua, this.captchaPredial, "2");
          }else{
            this.cuentaAgua = '';
          }
        }

        this.cuentaAgua = ''
      }
      
    },
    getLiquidacion(tipoPadron, clave, captcha, tipoLiq){ //tipoLiq 1:anual 2:periodo
      this.tipoPadron = tipoPadron;/*Se asigna a una variable para usarse en el metodo getLiquidacionSelected y genLineaCaptura*/
      this.clavePost = clave;/*Se asigna a una variable para usarse en el metodo getLiquidacionSelected y genLineaCaptura*/

      //zacatlan
      if(this.mpio=='zacatlan'){
        this.clavePost = this.tipoPredio.substring(0,1)+'-'+String(clave).padStart(7, '0');
      }

      this.tipoLiq = tipoLiq;/*Se asigna a una variable para usarse en el metodo getLiquidacionSelected y genLineaCaptura*/
      this.$store.commit("updateIdxUltParcialidadContribuyente", 99);
      this.$store.commit("updateIsCalculandoContribuyente", true);
      this.cleanMsgError();
      axios(
        getGetConfig(server.consultaadeudo, null, null, {tipoPadron:tipoPadron, claveContribuyente:this.clavePost, idxUltParcialidad:this.idxUltParcialidad, captcha: captcha, codeClient:this.$route.params.municipio, tipoLiq:tipoLiq, datoV:this.datoV})
      )
      .then(res => {
        this.isShowMsgCaptcha = false;
        this.$store.commit("updateDatosPagoContribuyente", res.data[0]);
        this.$store.commit("updateParcialidadesContribuyente", res.data[1]);
        this.$store.commit("updateTotalLiquidacionContribuyente", res.data[2]);
        this.$store.commit("updateResumenLiquidacion", res.data[3]);
        this.$store.commit("updateIsCalculandoContribuyente", false);
        this.cleanCaptchas();
      }).catch(err => {
        handledError(err, server.consultaadeudo, this.$router, this.$store);
        this.$store.commit("updateIsCalculandoContribuyente", false);
        this.cleanCaptchas();
      });
    },
    getLiquidacionSelected(idxSelected){
      this.$store.commit("updateIdxUltParcialidadContribuyente", idxSelected);
      if(!this.isCalculando){
        this.$store.commit("updateIsCalculandoContribuyente", true);
        axios(
          getGetConfig(server.consultaadeudo, null, null, {tipoPadron:this.tipoPadron, claveContribuyente:this.clavePost, idxUltParcialidad:this.idxUltParcialidad, captcha: null, codeClient:this.$route.params.municipio, tipoLiq:this.tipoLiq, datoV:this.datoV})
        )
        .then(res => {
            this.$store.commit("updateDatosPagoContribuyente", res.data[0]);
            this.$store.commit("updateParcialidadesContribuyente", res.data[1]);
            this.$store.commit("updateTotalLiquidacionContribuyente", res.data[2]);
            this.$store.commit("updateResumenLiquidacion", res.data[3]);
            this.$store.commit("updateIsCalculandoContribuyente", false);
        }).catch(err => {
            handledError(err, server.consultaadeudo, this.$router, this.$store);
            this.$store.commit("updateIsCalculandoContribuyente", false);
        });
      }
    },
    solicitarPago(){
      if(this.servicios.solicitaContactoPago){
        this.abrirModalPago();
      }else{
        this.generarPagoEnLinea();
      }
    },
    generarPagoEnLinea(){
      if(!this.isCalculando && !this.isGenerando ){
        this.$store.commit("updateIsGenerandoContribuyente", true);
        this.cleanMsgError();
        axios(
            getPostConfig(server.generarLineaCapturaMeta, null, null, {tipoPadron:this.tipoPadron, claveContribuyente:this.clavePost, idxUltParcialidad:this.idxUltParcialidad, codeClient:this.$route.params.municipio, tipoLiq:this.tipoLiq, datoV:this.datoV})
        ).then(res => {
            this.contenidoLineaCaptura = res.data;
            var serie = this.contenidoLineaCaptura.folio.substring(0,3);
            var folio = this.contenidoLineaCaptura.folio.substring(3,9);
            var total = this.contenidoLineaCaptura.total.replace(/,/g, '');
            axios(
                getPostConfig(server.generaPagoEnLinea, null, null, {serie:serie,folio:folio,total:total,correo:this.correoParaPago,codeClient:this.$route.params.municipio})
            ).then(res => {
                //this.urlForPayment = res.data; //para mostrarla embebida
                window.open(res.data, '_blank') //para redireccionar a una nueva pagina
                this.$store.commit("updateIsGenerandoContribuyente", false);
                this.cleanResults();
                this.isShowModalInfoPagoEnLinea=false;
            }).catch(err => {
                this.$store.commit("updateIsGenerandoContribuyente", false);
                handledError(err, server.generaPagoEnLinea, this.$router, this.$store);
            })
        }).catch(err => {
            this.$store.commit("updateIsGenerandoContribuyente", false);
            handledError(err, server.generarLineaCapturaMeta, this.$router, this.$store);
        })
      }
    },
    borrarDatosPago(){
      this.correoParaPago=null;
      if( this.urlForPayment!=null && this.urlForPayment!=''){//solo si ya se genero una orden
        this.contenidoLineaCaptura=null;
        this.urlForPayment=null;
        this.cleanResults();
      }
    },
    abrirModalPago(){
      window.scroll(0, 0);
      this.correoParaPago=null;
      this.urlForPayment=null;
      this.isShowModalInfoPagoEnLinea=true;
    },
    generarLineaCaptura(isSoloImprimir){
      if(!this.isCalculando && !this.isGenerando ){
          this.$store.commit("updateIsGenerandoContribuyente", true);
          if(isSoloImprimir){
              this.$store.commit("updateIsGenerandoContribuyente", false);
              this.generarPdf(isSoloImprimir);
          }else{
            this.cleanMsgError();
            axios(
                getPostConfig(server.generarLineaCaptura, null, null, {tipoPadron:this.tipoPadron, claveContribuyente:this.clavePost, idxUltParcialidad:this.idxUltParcialidad, codeClient:this.$route.params.municipio, tipoLiq:this.tipoLiq, datoV:this.datoV})
            ).then(res => {
                this.pdfGenerated = res.data;
                //this.generarPdf(isSoloImprimir);
                this.isShowModalLineaCaptura = true;
                this.$store.commit("updateIsGenerandoContribuyente", false);
            }).catch(err => {
                this.$store.commit("updateIsGenerandoContribuyente", false);
                handledError(err, server.generarLineaCaptura, this.$router, this.$store);
            })
          }   
      }
    },
    // generarPdf(isSoloImprimir){
    //   if(isSoloImprimir){
    //     this.soloImprimir();
    //   }else{
    //     var detalle = this.tipoLiq=='2'?'PAGO DE COLEGIATURA ...' :this.contenidoLineaCaptura.detalle; //eSTO ES TEMPORAL
    //     var totalLiquidacion = this.contenidoLineaCaptura.total;
    //     var fecha = this.contenidoLineaCaptura.fecha;
    //     var fechav = this.contenidoLineaCaptura.fechav;
    //     var formasPago = [this.contenidoLineaCaptura.formasPago.length];
    //     var folio = this.contenidoLineaCaptura.folio;
    //     var logoMpio2 = this.contenidoLineaCaptura.logoMpio2;
    //     var qrCodi = this.contenidoLineaCaptura.qrCodi;
    //     for (var idxFormasPago in this.contenidoLineaCaptura.formasPago){
    //       formasPago[idxFormasPago] = [this.contenidoLineaCaptura.formasPago[idxFormasPago].nombre + " - " + this.contenidoLineaCaptura.formasPago[idxFormasPago].ref];
    //     }
    //     var parcialidades = [this.contenidoLineaCaptura.parcialidades.length];
    //     for (var index in this.contenidoLineaCaptura.parcialidades){
    //       if(this.contenidoLineaCaptura.parcialidades[index].pagar){
    //         parcialidades[index] = [
    //             this.contenidoLineaCaptura.parcialidades[index].periodo, 
    //             this.contenidoLineaCaptura.parcialidades[index].importe, 
    //             this.contenidoLineaCaptura.parcialidades[index].recargo, 
    //             this.contenidoLineaCaptura.parcialidades[index].multa, 
    //             this.contenidoLineaCaptura.parcialidades[index].pae, 
    //             this.contenidoLineaCaptura.parcialidades[index].subsidios, 
    //             this.contenidoLineaCaptura.parcialidades[index].total ]
    //       }
    //     }
    //     this.pdfGenerated = genPdfLinea(detalle, parcialidades, totalLiquidacion, formasPago, true, fecha, fechav, folio, logoMpio2, qrCodi, this.$route.params.municipio);
    //   }
    //   this.isShowModalLineaCaptura = true;
    //   this.cleanResults();
    // },
    soloImprimir(){
      var parcialidadesCobrables = [this.idxUltParcialidad+1];
        for (var index in this.parcialidades){
            if(parseInt(index) <= this.idxUltParcialidad){
              parcialidadesCobrables[index] = [ 
                  this.parcialidades[index].periodo, 
                  this.parcialidades[index].importe, 
                  this.parcialidades[index].recargo, 
                  this.parcialidades[index].multa, 
                  this.parcialidades[index].pae, 
                  this.parcialidades[index].subsidios, 
                  this.parcialidades[index].total ]
            }
        }
        this.pdfGenerated = genPdfLinea(this.datosPago[0].detalle, parcialidadesCobrables, this.totalLiquidacion, null, false, null, null, null, null);
    },
    printOrdenPago(){
      document.getElementById('embed1').contentWindow.print();
    },
    focusModalPago(){
      this.$refs.focusCorreoPago.focus();
    },  
  },
  validations:{
    cuentaMensual:{
            required,
            alphaNum,
            minLength: minLength(16),
            maxLength: maxLength(16)
          },
    cuentaAgua:{
            required,
            minLength: minLength(1),
            maxLength: maxLength(20)
    },
    claveCatastral:{
            required,
            minLength: minLength(1),
            maxLength: maxLength(16)
          },
    
    
    /*email:{
            required,
            minLength: minLength(5),
            maxLength: maxLength(200)
    },*/
    emailPago:{
            required,
            minLength: minLength(5),
            maxLength: maxLength(200)
    }
  }
}
</script>
<style>
.row-to-img-orden{
  margin-left:40px;
}
.button-reenviar{
  margin-top: 5px;
}
.dropdown{
  margin-bottom: 5px;
}
.input-folio{
  margin-top:10px;
}
.input-serie{
  margin-top:10px;
}
.b-icon-info-recibo{
  margin-right:20px;
}
.margin-radio-recibo{
  margin-right:5px;
}
.margin-radio-linea{
  margin-right:5px;
}
.link-pdf{
  margin-left:20px;
}
.margin{
  margin: 5px auto;
}
div.error{
  color: red;
}
div.success{
  color: green;
  margin-bottom: 10px;
}

/*------------------------------------------------------------------------------- THEMS -------------------------------------------------------------------------- */
.teotihuacan:hover{
   background-color:#A03455;
   border-color:#A03455;
}
.teotihuacan{
   background-color:#9D2449; 
   border-color:#9D2449;
}
.demo:hover{
  background-color:#5F58B1;
   border-color:#5F58B1;
}
.demo{
  background-color:#312991; 
   border-color:#312991;
}
</style>